import { AfterViewInit, Component, ElementRef, Inject, PLATFORM_ID, ViewChild, ViewEncapsulation } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { initializeGoogleMapsPlacesAutocomplete, SearchLocationData } from '@hiptraveler/common';

@Component({
  selector: 'main-info',
  templateUrl: './main-info.component.html',
  styleUrls: ['./main-info.component.scss'],
  host: { class: 'page-profile-custom-activity-dialog-main-info' },
  encapsulation: ViewEncapsulation.None
})
export class MainInfoComponent implements AfterViewInit {

  @ViewChild('formAddress') formAddress: ElementRef<HTMLInputElement>;
  @ViewChild('formCity') formCity: ElementRef<HTMLInputElement>;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(MAT_DIALOG_DATA) public form: FormGroup
  ) { }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      initializeGoogleMapsPlacesAutocomplete(this.formAddress, { default: true }).subscribe((response) => {
        this.form.patchValue({
          address: this.formAddress.nativeElement.value
        });
        this.form.get('locationMap')?.patchValue({
          id: response?.place_id
        });
      });
    }
  }

  async cityLocationChanges(locationData: SearchLocationData): Promise<void> {
    this.formCity.nativeElement.value = locationData?.name || '';
    this.form.get('locationMap')?.patchValue({
      city: locationData?.name
    });
  }

  async countryLocationChanges(locationData: SearchLocationData): Promise<void> {
    this.form.get('locationMap')?.patchValue({
      country: locationData?.country
    });
  }

}
